import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sm:col-span-1"
}
const _hoisted_2 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_4 = { class: "sr-only" }
const _hoisted_5 = { class: "space-y-1" }
const _hoisted_6 = {
  key: 1,
  class: "w-full"
}
const _hoisted_7 = { class: "block uppercase tracking-wide text-darkGray-1 text-xs font-bold" }

import { computed, ref, onMounted } from "vue";
import { defineEmits, reactive } from "@vue/runtime-core";
import * as dtos from "@/models/dtos";
import InputPeriodCheckbox from "./InputPeriodCheckbox.vue";
import { RangeRoot } from "@/models/forms/AgePeriod";

export default /*@__PURE__*/_defineComponent({
  __name: 'InputPeriodCheckboxGroup',
  props: {
  model: {
    required: true,
    type: dtos.DynamicProperty,
  },
  placeholder: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["change"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const periodsWithRange = reactive(new Array<RangeRoot>());
const withoutGroup = computed(() =>
  periodsWithRange.filter((px) => px.input.type !== "periodGroup")
);

const props = __props;

onMounted(() => {
  var properties = (
    model.value.data.metadata as dtos.MetaData
  ).properties.filter((x) => props.model.data.keys.includes(x.key));
  properties.forEach((x) => {
    periodsWithRange.push(new RangeRoot(x));
  });
});

let model = ref(props.model);

function onChange(e: any) {
  emit("change", e);
}

return (_ctx: any,_cache: any) => {
  return (props.adminView)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("dt", _hoisted_2, _toDisplayString(_unref(model)?.label), 1),
        _createElementVNode("dd", _hoisted_3, [
          _createElementVNode("fieldset", null, [
            _createElementVNode("legend", _hoisted_4, _toDisplayString(_unref(model)?.label), 1),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(withoutGroup.value, (item, index) => {
                return (_openBlock(), _createBlock(InputPeriodCheckbox, {
                  key: index,
                  label: item?.input.label,
                  model: item.input,
                  id: item?.input.key,
                  onChange: onChange,
                  disabled: !__props.editMode,
                  "admin-view": true
                }, null, 8, ["label", "model", "id", "disabled"]))
              }), 128))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(model).label), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(withoutGroup.value, (item, index) => {
          return (_openBlock(), _createBlock(InputPeriodCheckbox, {
            key: index,
            label: item?.input.label,
            model: item.input,
            id: item?.input.key,
            onChange: onChange,
            disabled: __props.disabled
          }, null, 8, ["label", "model", "id", "disabled"]))
        }), 128))
      ]))
}
}

})